import { GET_DETAIL_EXPERIENCE_REVIVE } from 'constants/detail-experience-inspire';

const initialState = {
  isFetching: false,
  data: {},
  error: null,
};

export const detailExperienceReviveReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case `${GET_DETAIL_EXPERIENCE_REVIVE}_PENDING`: {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    }
    case `${GET_DETAIL_EXPERIENCE_REVIVE}_FULFILLED`: {
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    }
    case `${GET_DETAIL_EXPERIENCE_REVIVE}_REJECTED`: {
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};
